export class TagManagerService {

    constructor() {}

    buildItemAdicionado(carrinho, itemAdicionado) {
        const itens = carrinho.itensCarrinhoCompra;

        if(!itens || itens.length === 0) return "";

        const item = itens.filter((item) => {
            return item.codigo == itemAdicionado.codigoItem;
        });

        if(!item || item.length === 0) return "";

        return {
            event: "addToCart",
            cartProductName: item[0].nome,
            cartProductSku: item[0].codigo,
            cartProductPrice: item[0].valorPorUnitarioFloat,
            cartProductQuantity: item[0].quantidade
        }
    }

    buildEmailNewsLetter() {
        return {
            "event": "cadastroNewsRodape"
        };
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/tag-manager/tagManager.service.js